/** The chat refusals an operator may meet (each a `reasonCode`). */
export const OPS_CHAT_REFUSAL_REASON_CODES = [
    'RIDE_CHAT_RECIPIENT_INVALID', 'RIDE_CHAT_BODY_REQUIRED', 'RIDE_CHAT_BODY_TOO_LONG', 'RIDE_CHAT_BODY_AND_REPLY', 'RIDE_CHAT_QUICK_REPLY_UNKNOWN',
    'RIDE_CHAT_NOT_STARTED', 'RIDE_CHAT_CLOSED', 'RIDE_CHAT_NO_DRIVER', 'RIDE_CHAT_RATE_LIMITED',
];
/** The stable refusals of the order routes (each a `reasonCode`; `CONSENT_CODE_INVALID` carries `params: { attemptsRemaining }`; `ORDER_NOT_PENDING` carries `params: { status }` — D577, the glued `detail` texts are deprecated). */
export const CENTRAL_ORDER_REFUSAL_CODES = [
    'RIDER_NOT_FOUND', 'RIDER_NOT_ACTIVE', 'RIDER_PHONE_INVALID', 'PAYMENT_METHOD_NOT_FOR_CENTRAL', 'CONSENT_DELIVERY_FAILED', 'CONSENT_RATE_LIMITED',
    'CONSENT_CODE_INVALID', 'CONSENT_CODE_EXPIRED', 'CONSENT_LOCKED', 'ORDER_NOT_PENDING', 'ORDER_OF_ANOTHER_OPERATOR', 'QUOTE_EXPIRED', 'QUOTE_NOT_ACKNOWLEDGED',
    'SUPPORT_SUBJECT_LOOKUP_RATE_LIMITED', 'IDEMPOTENCY_KEY_REQUIRED', 'CENTRAL_ORDER_FIELDS_REQUIRED',
];
export class CentralDeskApi {
    client;
    constructor(client) {
        this.client = client;
    }
    // chat
    /** The market's live conversations, most recently active first (`ride_chat:read`). */
    rideChats(market, limit) {
        return this.client.request({ method: 'GET', path: `/v1/ops/ride-chats?market=${encodeURIComponent(market)}${limit !== undefined ? `&limit=${limit}` : ''}`, auth: true });
    }
    /** The operator's ready messages in a language (`ride_chat:read`). */
    /** D826: listen to a voice message of a ride of the operator's market (`ride_chat:read`). */
    rideChatAudio(rideId, messageId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/rides/${encodeURIComponent(rideId)}/messages/${encodeURIComponent(messageId)}/audio`, auth: true });
    }
    rideChatQuickReplies(market, language) {
        return this.client.request({ method: 'GET', path: `/v1/ops/ride-chats/quick-replies?market=${encodeURIComponent(market)}&language=${encodeURIComponent(language)}`, auth: true });
    }
    /** A ride's whole thread (`ride_chat:read` at the ride's market). */
    rideThread(rideId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/rides/${encodeURIComponent(rideId)}/messages`, auth: true });
    }
    /** Speak in a ride's chat as the central (`ride_chat:send`); a refusal carries one of `OPS_CHAT_REFUSAL_REASON_CODES`. */
    sendRideMessage(rideId, input) {
        return this.client.request({ method: 'POST', path: `/v1/ops/rides/${encodeURIComponent(rideId)}/messages`, body: input, auth: true });
    }
    // the new order
    /** What the central may sell now at a market (`central_order:view`). */
    options(market) {
        return this.client.request({ method: 'GET', path: `/v1/central/options?market=${encodeURIComponent(market)}`, auth: true });
    }
    /** Step 1: look the caller up, quote the trip for them and send them the consent code (`central_order:create`). */
    startOrder(input) {
        return this.client.request({ method: 'POST', path: '/v1/central/orders', body: input, auth: true });
    }
    /** Step 2: the caller read the code out — check it and request the ride. */
    confirmOrder(orderId, input) {
        return this.client.request({ method: 'POST', path: `/v1/central/orders/${encodeURIComponent(orderId)}/confirm`, body: input, auth: true });
    }
    /** Abandon a pending order. */
    cancelOrder(orderId, marketId) {
        return this.client.request({ method: 'POST', path: `/v1/central/orders/${encodeURIComponent(orderId)}/cancel`, body: { marketId }, auth: true });
    }
    /** The orders the market's central took, newest first (`central_order:view`). */
    orders(market, status) {
        return this.client.request({ method: 'GET', path: `/v1/central/orders?market=${encodeURIComponent(market)}${status !== undefined ? `&status=${status}` : ''}`, auth: true });
    }
    // courier incidents
    /** What couriers reported in a market, newest first (`courier_job:view`). */
    courierIncidents(market, status) {
        return this.client.request({ method: 'GET', path: `/v1/courier-dispatch/incidents?market=${encodeURIComponent(market)}${status !== undefined ? `&status=${status}` : ''}`, auth: true });
    }
    /** Close a report once the operator acted (`courier_job:release`). */
    resolveCourierIncident(incidentId, marketId, resolution) {
        return this.client.request({ method: 'POST', path: `/v1/courier-dispatch/incidents/${encodeURIComponent(incidentId)}/resolve`, body: { marketId, resolution }, auth: true });
    }
}
//# sourceMappingURL=central-desk.js.map